import { render, staticRenderFns } from "./paso4.vue?vue&type=template&id=671a7cc6&scoped=true&"
import script from "./paso4.vue?vue&type=script&lang=ts&"
export * from "./paso4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671a7cc6",
  null
  
)

export default component.exports